import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import React from 'react';
import styled, { ThemeColors } from 'styled-components';
import Flex from './Flex';
import Text from './Text';
import Button from './Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { shade } from 'polished';

interface Props {
    onClick: () => void;
    icon: IconDefinition;
    label?: string;
    testId?: string;
    disabled?: boolean;
    main?: boolean;
    bgColor?: keyof ThemeColors;
    color?: keyof ThemeColors;
}

const NavBtn: React.FC<Props> = ({ onClick, icon, label, testId, disabled, main, bgColor, color }) => {
    const resolvedBgColor = bgColor ?? (main ? 'main' : 'fillWhite');
    const resolvedTextColor = color ?? (main ? 'fillWhite' : 'text');

    return (
        <StyledContainer align="center" bgColor={resolvedBgColor} color={resolvedTextColor}>
            <FontAwesomeIcon icon={icon} />
            <StyledButton
                disabled={disabled}
                data-testid={testId}
                onClick={onClick}
                color={resolvedTextColor}
                bgColor={resolvedBgColor}
            >
                <StyledLabel disabled={disabled} as="label" $colorKey={resolvedTextColor} $bgColorKey={resolvedBgColor}>
                    {label}
                </StyledLabel>
            </StyledButton>
        </StyledContainer>
    );
};

export default NavBtn;

const StyledLabel = styled(Text)<{
    disabled?: boolean;
    $colorKey?: keyof ThemeColors;
    $bgColorKey?: keyof ThemeColors;
}>`
    cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
    color: ${({ theme, disabled, $colorKey }) =>
        disabled ? theme.colors.textDisabled : theme.colors[$colorKey ?? 'text']};
    background-color: transparent;
`;

const StyledButton = styled(Button)<{ bgColor?: keyof ThemeColors; color?: keyof ThemeColors }>`
    cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
    background-color: transparent;
    color: ${({ theme, color }) => theme.colors[color ?? 'text']};
    padding: 0 0.75rem;

    &:hover {
        background-color: transparent;
    }
`;

const StyledContainer = styled(Flex)<{ bgColor?: keyof ThemeColors; color?: keyof ThemeColors; disabled?: boolean }>`
    border-radius: var(--radius);
    cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
    border: ${({ theme }) => `1px solid ${theme.colors.borderLight}`};
    padding: 0 0.75rem;
    background-color: ${({ theme, bgColor }) => theme.colors[bgColor ?? 'fillWhite']};
    color: ${({ theme, color }) => theme.colors[color ?? 'text']};

    &:hover {
        opacity: ${({ disabled }) => (disabled ? 1 : 0.8)};
        background-color: ${({ theme, bgColor, disabled }) =>
            disabled
                ? theme.colors[bgColor ?? 'fillWhite']
                : bgColor
                ? shade(0.1, theme.colors[bgColor])
                : theme.colors.fillWhite};
    }
`;
